import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@ipc/ipc-components';
import { PanelContent } from '../../../styles';
import { FormLabel } from '../../../elements';
import SecureComponent from '../../../components/custom/SecureComponent';
import { ROLE_ADMIN, ROLE_CARRIER, ROLE_OPERATOR } from '../../../utils/access';
import { MultiSelectWrapper } from '../../../elements/SplitListSelect/styles';
import { ChildrenWrapper } from '../../../elements/FormLabel/styles';
import SplitListSelect from '../../../elements/SplitListSelect';

const RouteComponent = ({
  options, validations, selectChangeHandler, disabled, values,
}) => {
  const getWithFullCarrierLabel = () => {
    if (values && values.carrier && options.carrier) {
      const isCarrierArray = Array.isArray(values.carrier);
      const carrierObj = isCarrierArray
        ? options.carrier.filter(item => values.carrier.some(carrierLabel => item.label === carrierLabel.label))
        : options.carrier.find(item => item.value === values.carrier.value);
      return {
        ...values,
        carrier: carrierObj,
      };
    }
    return values;
  };

  return (
    <Panel title="Route" expanded>
      <PanelContent>
        <div className="FormRow">
          <div className="FormRowInline">
            <MultiSelectWrapper>
              <FormLabel title="Origin" required hasError={!validations.origin} />
              <ChildrenWrapper hasError={!validations.origin}>
                <SplitListSelect
                  allAllowed
                  values={values}
                  disabled={disabled}
                  propertyName="origin"
                  validations={validations}
                  selectChangeHandler={selectChangeHandler}
                  options={options.iata}
                />
              </ChildrenWrapper>
            </MultiSelectWrapper>
          </div>
          <div className="FormRowInline">
            <MultiSelectWrapper>
              <FormLabel title="Destination" required hasError={!validations.destination} />
              <ChildrenWrapper hasError={!validations.destination}>
                <SplitListSelect
                  allAllowed
                  values={values}
                  disabled={disabled}
                  propertyName="destination"
                  selectChangeHandler={selectChangeHandler}
                  options={options.iata}
                />
              </ChildrenWrapper>
            </MultiSelectWrapper>
          </div>
        </div>
        <div className="FormRow">
          <SecureComponent roles={[ROLE_ADMIN, ROLE_OPERATOR]}>
            <div className="FormRowInline">
              <MultiSelectWrapper>
                <FormLabel title="Carrier" required hasError={!validations.carrier} />
                <ChildrenWrapper hasError={!validations.carrier}>
                  <SplitListSelect
                    values={getWithFullCarrierLabel()}
                    disabled={disabled}
                    propertyName="carrier"
                    options={options.carrier}
                    selectChangeHandler={selectChangeHandler}
                  />
                </ChildrenWrapper>
              </MultiSelectWrapper>
            </div>
          </SecureComponent>
          <SecureComponent roles={[ROLE_ADMIN, ROLE_CARRIER]}>
            <div className="FormRowInline">
              <MultiSelectWrapper>
                <FormLabel title="Postal Operator" required hasError={!validations.operator} />
                <ChildrenWrapper hasError={!validations.operator}>
                  <SplitListSelect
                    values={values}
                    disabled={disabled}
                    propertyName="operator"
                    options={options.operator}
                    selectChangeHandler={selectChangeHandler}
                  />
                </ChildrenWrapper>
              </MultiSelectWrapper>
            </div>
          </SecureComponent>
        </div>
      </PanelContent>
    </Panel>
  );
};

RouteComponent.propTypes = {
  disabled: PropTypes.bool,
  options: PropTypes.shape(),
  validations: PropTypes.shape(),
  selectChangeHandler: PropTypes.func,
  values: PropTypes.shape(),
};
export default RouteComponent;
